<ng-container *ngIf="!!samples && !!samples?.length">
    <p-accordion (onOpen)="onAccordionOpen($event)"
                 expandIcon="icon__expand"
                 collapseIcon="icon__collapse"
                 [multiple]="true" styleClass="specimen-dropdown">
        <p-accordionTab *ngFor="let sample of samples ; let i =index; trackBy:samplesCompare "
                        class="{{buildAutomationClass(sample)}}">
            <p-header>
                <div class="specimen-header">
                    <div class="specimen-name">
                        <span>{{sample?.identifiers ? sample?.identifiers[0] : ''}}&nbsp;</span>
                        <ng-container *ngIf="sample?.objectType?.toLowerCase() != 'dynamic'">
                            <ng-container [ngSwitch]="sample?.objectType?.toLowerCase()">
                                <span *ngSwitchCase="'tumor'">(Tumor)</span>
                                <span *ngSwitchCase="'normal'">(Normal / Germline)</span>
                            </ng-container>
                        </ng-container>
                        <ng-container *ngIf="sample?.objectType?.toLowerCase() == 'dynamic' && sample?.sampleType">
                            <ng-container [ngSwitch]="sample?.sampleType?.toLowerCase()">
                                <span *ngSwitchCase="'tumor'">{{'Tumor specimen information' | stringTranslate}}</span>
                                <span *ngSwitchCase="'normal'">{{'Normal specimen information' | stringTranslate}}</span>
                            </ng-container>
                        </ng-container>
                    </div>
                    <div class="specimen-icons">
                        <span *ngIf="sample?.id == primaryid || sample?.isPrimary === true" class="badge badge-success">Primary</span>
                        <span *ngIf="sample?.isInvalid" class="badge badge-danger">Invalid</span>
                    </div>
                </div>
            </p-header>
            <gen-sample-generic
                    [disabledForced]="disabledForced"
                    [editMode]="editMode"
                    [sample]="sample"
                    [index]="i"
                    [allowedit]="allowedit"
                    [overrides]="overrides"
                    [markAsPrimaryEnabled]="markAsPrimaryEnabled"
                    [proceedToAnaliseStarted]="proceedToAnaliseStarted"
                    (primarySampleChanged)="primarySampleChanged($event)"
                    (sampleUpdate)="updateSample(sample,$event)"
            ></gen-sample-generic>
        </p-accordionTab>
    </p-accordion>
</ng-container>

<ng-container *ngIf="!samples || !samples?.length">
    <section class="Flexbox Flexbox__just-center fs5_5"> No Specimens Added
    </section>
</ng-container>
